var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", [
      _c("tr", [
        _c("td", [
          _c("div", { staticStyle: { float: "left" } }, [
            _c("h1", [_vm._v(_vm._s(_vm.translateWords.RackManage))])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("tr", [
        _c(
          "td",
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "200px"
                }
              },
              [
                _c("table", [
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.RackNo,
                              prop: "RackNo"
                            }
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: _vm.ruleForm.RackNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "RackNo", $$v)
                                },
                                expression: "ruleForm.RackNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.Code,
                              prop: "Code"
                            }
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "400px" },
                              attrs: {
                                disabled: true,
                                placeholder: _vm.translateWords.autoProdut
                              },
                              model: {
                                value: _vm.ruleForm.Code,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "Code", $$v)
                                },
                                expression: "ruleForm.Code"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.PositionId,
                              prop: "PositionId"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "400px" },
                                attrs: {
                                  placeholder: _vm.translateWords.select,
                                  filterable: ""
                                },
                                model: {
                                  value: _vm.ruleForm.PositionId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "PositionId", $$v)
                                  },
                                  expression: "ruleForm.PositionId"
                                }
                              },
                              _vm._l(_vm.PositionIdoptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "300px" },
                            attrs: {
                              label: _vm.translateWords.IsUseRackLayer,
                              prop: "IsUseRackLayer"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  placeholder: _vm.translateWords.select,
                                  filterable: ""
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.selectvalue(
                                      _vm.ruleForm.IsUseRackLayer
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.ruleForm.IsUseRackLayer,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.ruleForm,
                                      "IsUseRackLayer",
                                      $$v
                                    )
                                  },
                                  expression: "ruleForm.IsUseRackLayer"
                                }
                              },
                              _vm._l(_vm.IsUseRackLayeroptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.isshowlayer
                    ? _c("tr", [
                        _c(
                          "td",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.translateWords.LayerNo,
                                  prop: "LayerNo"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "" },
                                  model: {
                                    value: _vm.ruleForm.LayerNo,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleForm, "LayerNo", $$v)
                                    },
                                    expression: "ruleForm.LayerNo"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isshowlayer
                    ? _c("tr", [
                        _c(
                          "td",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: _vm.translateWords.SubCode,
                                  prop: "SubCode"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: _vm.translateWords.autoProdut,
                                    disabled: true
                                  },
                                  model: {
                                    value: _vm.ruleForm.SubCode,
                                    callback: function($$v) {
                                      _vm.$set(_vm.ruleForm, "SubCode", $$v)
                                    },
                                    expression: "ruleForm.SubCode"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { width: "300px" },
                            attrs: {
                              label: _vm.translateWords.RackStatus,
                              prop: "IsUseRack"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  placeholder: _vm.translateWords.select
                                },
                                model: {
                                  value: _vm.ruleForm.IsUseRack,
                                  callback: function($$v) {
                                    _vm.$set(_vm.ruleForm, "IsUseRack", $$v)
                                  },
                                  expression: "ruleForm.IsUseRack"
                                }
                              },
                              _vm._l(_vm.IsUseRackoptions, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c(
                      "td",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.translateWords.Remark,
                              prop: "Remark"
                            }
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                type: "textarea",
                                rows: 2,
                                placeholder: ""
                              },
                              model: {
                                value: _vm.ruleForm.Remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.ruleForm, "Remark", $$v)
                                },
                                expression: "ruleForm.Remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { staticStyle: { float: "left" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("ruleForm")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.translateWords.save))]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5848e518", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5848e518","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddRack.vue
// module id = null
// module chunks = 